import styled, { Theme } from 'styled-components';
import { Container } from 'reactstrap';
import { themeColor } from '@whitelabel/helpers/style/colors';
import { mediaBreakpointUp } from '@whitelabel/helpers/style/grid';

export const StyledSecondaryNavBar = styled.nav<{ $themeColor?: keyof Theme['themeColors'] }>`
  padding-block: 1rem;
  background-color: ${({ $themeColor }) => themeColor($themeColor ?? 'tertiaryBg')};

  // To reduce layout shift
  display: none;
  min-height: 0;
  ${mediaBreakpointUp('lg')`
    display: block;
    min-height: 3rem;
  `}

  .container {
    column-gap: 1.5rem;
  }
`;

export const StyledAccountSecondaryNavBar = styled.nav<{ $themeColor?: keyof Theme['themeColors'] }>`
  padding-block: 0.5rem;
  background-color: ${({ $themeColor }) => themeColor($themeColor ?? 'tertiaryBg')};

  // To reduce layout shift
  display: block;
  min-height: 3rem;

  .container {
    padding-inline: 0;
    justify-content: center;
    column-gap: 0.5rem;

    a {
      padding-block: 0.5rem;
      padding-inline: 0.25rem;
      width: fit-content;
      font-size: 0.75rem;
      margin-bottom: 0;
    }

    ${mediaBreakpointUp('sm')`
      padding-inline: 1rem;
      justify-content: flex-start;
      column-gap: 1.5rem;
      a {
        font-size:0.875rem;
      }
    `}

    ${mediaBreakpointUp('md')`
      padding-inline: 1.5rem;
    `}

    ${mediaBreakpointUp('lg')`
      padding-inline: 2rem;
    `}
  }
`;

export const StyledContainer = styled(Container)`
  display: flex;
  align-content: center;
  flex-wrap: wrap;
  height: 100%;
`;
